import React from "react";
import { globalFileServer } from "../../../axiosInstance";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProductAddToCart from "../routs/productPage/ProductAddToCart";
import ProductInfo from "../productInfo/ProductInfo";
import { CollectSiteProductRemoveProduct } from "../../server/CollectSite";
import { setToggleCart } from "../../server/CartsOpen";
import { showAlertWithConfirm } from "../../server/ShowAlert";
import { upsertCartItem } from "../../server/CollectSite";
import { useEffect } from "react";

const MiniCart = ({ setProductPopUp, setSelectedProd }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    productsInCart,
    user,
    role,
    deliveryPrice,
    orderSum,
    deliveryAvailable,
    stationId,
  } = useSelector((state) => ({
    productsInCart: state.productsInCart.productsInCart,
    user: state.user.user,
    role: state.user.role,
    deliveryPrice: state.productsInCart.deliveryPrice,
    stationId: state.user.stationId,
  }));
  console.log("productsInCart in MiniCart:", productsInCart);

  const totalItems = productsInCart.reduce(
    (total, item) => total + item.quantity,
    0
  );

  const subtotal = productsInCart.reduce((total, item) => {
    return total + item.totalPrice;
  }, 0);
  //TODO - לשלב את ההנחות כאן
  const saleTotal = productsInCart.reduce((total, item) => {
    if (item.promoId) {
      return total + (item.unitPrice * item.quantity - item.totalPrice);
    } else {
      return total;
    }
  }, 0);

  const totalPrice = subtotal + (deliveryPrice ?? 0);
  const goToCart = () => {
    dispatch(setToggleCart(false)); // סגירת הסיידבר אם קיים
    const unavailableItems = productsInCart.filter(
      (product) => product.quantity == 0
    );
    if (unavailableItems.length > 0) {
      const itemNames = unavailableItems
        .map((item) => item.ProductName)
        .join("<br>");
      showAlertWithConfirm({
        msgHtml: `<div class="missing-items-alert">שים לב: הפריטים הבאים אזלו מהמלאי:<div class="missing-items-container"><strong>${itemNames}</strong></div></div>`,
      });
    }
    navigate("/cart");
  };

  let inSale;

  const isInSale = (product) => {
    console.log("is in sale", product);
    return product.promoId &&
      product.quantity * product.unitPrice !== product.totalPrice
      ? true
      : false;
  };

  return (
    <div className="header-cart">
      <div className="header-cart-wrap">
        <div className="products">
          <table>
            <tbody>
              {productsInCart.length
                ? productsInCart.map((element) => {
                    inSale = isInSale(element);
                    return (
                      <tr
                        className="item-mini-cart"
                        key={element.productId}
                        onClick={() => {
                          setProductPopUp(true);
                          setSelectedProd(element.product);
                        }}
                      >
                        <td className="prod-info-and-name">
                          <div className="delete-item">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                dispatch(
                                  upsertCartItem(
                                    `${element.product.gtin}-${element.product.variant}`,
                                    parseFloat(element.unitPrice).toFixed(2),
                                    0,
                                    String(stationId)
                                  )
                                );
                              }}
                              className="delete-btn"
                            >
                              <span className="delete-icon">✖</span>
                            </button>
                          </div>
                          <ProductInfo selectedProd={element.product} />

                          {element.promoId ? (
                            <p className="sale">במבצע!</p>
                          ) : null}
                          {element.warningMessage && (
                            <p className="comment-warning">
                              {element.warningMessage}
                            </p>
                          )}
                        </td>
                        <td className="price-details">
                          <p className="price">
                            {element.totalPrice.toFixed(2)} <span>₪</span>
                          </p>
                          {inSale ? (
                            <p className="sale">
                              {(
                                element.unitPrice * element.quantity -
                                element.totalPrice
                              ).toFixed(2)}{" "}
                              <span>- ₪</span>
                            </p>
                          ) : null}
                          <div
                            className="quantity"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <ProductAddToCart
                              element={element}
                              haveInfo={false}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
        </div>

        <div className="cart-summary">
          <div className="summary-row">
            <span>סה"כ:</span>
            <span>{subtotal.toFixed(2)} ₪</span>
          </div>
          <div className="summary-row">
            <span>חסכת</span>
            <span>{saleTotal.toFixed(2)} ₪</span>
          </div>
          <div className="summary-row">
            <span>משלוח:</span>
            <span>{deliveryPrice} ₪</span>
          </div>
          <div className="summary-row total">
            <span>סה"כ לתשלום:</span>
            <span>{totalPrice.toFixed(2)} ₪</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCart;
